import { useEffect, useState } from "react";
import { useDisclosure, Text, Switch, Flex, PinInput, HStack, PinInputField } from "@chakra-ui/react";
import { FirstStepIcon } from "@/styles/icons/FirstStepIcon";
import { SecondStepIcon } from "@/styles/icons/SecondStepIcon";
import { ThirdStep } from "@/styles/icons/ThirdStep";
import { generateTwoFactor, enableTwoFactor, getTwoFactorStatus } from "./useSegurity";
import { QRCodeSVG } from 'qrcode.react';
import { InfoIconOutlineYellow } from "@/styles/icons/InfoIconOutlineYellow";
import { showToast } from "@/utils";
import { Button, Modal } from "barte-design-system";



export function FirsStepModal() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isTwoFaEnabled, setIsTwoFaEnabled] = useState(false);
    const [step, setStep] = useState<number>(1)
    const [pin, setPin] = useState("");
    const [urlQrCode, setUrlQrcode] = useState<string>("");
    const Token = localStorage.getItem("barte-auth-token")
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [status2FA, setStatus2FA] = useState<boolean>(false)



    async function getStatus2FA() {
        try {
            const response = await getTwoFactorStatus(Token)
            setStatus2FA(Boolean(response))
        } catch (error) {
            setStatus2FA(false)
        }
    }

    useEffect(() => {
        getStatus2FA()
    }, [])


    const handleToggle = (e) => {
        if (e.target.checked) {
            setIsTwoFaEnabled(true);
            onOpen();
        } if (status2FA === true && e.target.checked === false) {
            onOpen();
            setIsTwoFaEnabled(status2FA);
            setStep(4)
        }
        else {
            setIsTwoFaEnabled(false);
        }
    };

    useEffect(() => {
        setIsTwoFaEnabled(status2FA)
    }, [status2FA])

    async function getQRCode() {
        setLoading(true)
        try {
            const response = await generateTwoFactor(Token)

            if (response.qrCodeUrl !== null) {
                setUrlQrcode(response?.qrCodeUrl)
                setStep(prev => prev + 1)
            }


        } catch (error) {
            return error
        } finally {
            setLoading(false)
        }
    }

    async function sendPinTwoFa() {
        setLoading(true)

        try {
            const response = await enableTwoFactor(Token, pin, "true")
            if (response) {
                setIsTwoFaEnabled(true);
                onClose()
                setPin(null)
                setStep(1)
                setError(false)
                setErrorMessage("")
                showToast({
                    type: "success",
                    message: "Duplo fator de autenticação ativado.",
                });
            }
    
        } catch (error) {
            showToast({
                type: "error",
                message: "Falha ao ativar duplo fator de autenticação.",
            });
            setIsTwoFaEnabled(false);
            setErrorMessage("Código inválido")
            setError(true)
        } finally {
            setLoading(false)
            getStatus2FA()
        }
    }

    async function desative2FA() {
        setLoading(true)

        try {
            const response = await enableTwoFactor(Token, pin, "false")
            if (response) {
                setStep(1)
                setIsTwoFaEnabled(false);
                onClose();

            }
        } catch (error) {

        } finally {
            setLoading(false)
        }
    }

    const handleCloseModal = () => {
        setIsTwoFaEnabled(status2FA);
        setStep(1)
        onClose();
    };
    useEffect(() => {
        getStatus2FA()
    }, [])

    return (
        <>
            <Switch id="TwoFa" sx={{
                "& .chakra-switch__track": {
                    backgroundColor: "gray.300",
                },
                "& .chakra-switch__track[data-checked]": {
                    backgroundColor: "red.500",
                },
                "& .chakra-switch__thumb": {
                    backgroundColor: "white",
                }
            }} isChecked={isTwoFaEnabled} onChange={handleToggle} />

            <Modal
                isOpen={isOpen && step !== 4}
                title="Configure Duplo Fator de Autenticação (2FA)"
                onClose={handleCloseModal}
                footer={{
                    primaryButton: {
                        children: step === 3 ? "Enviar" : "Próximo",
                        onClick: step === 1 ? getQRCode : step === 2 ? () => setStep(prev => prev + 1) : sendPinTwoFa,
                        loading: step === 3 ? loading : false,
                        disabled: step === 3 ? (loading || pin?.length < 6) : false,
                    },
                }}
            >
                <Text
                    fontSize="12px"
                    fontFamily="Hero New"
                    fontWeight="400"
                    lineHeight="14.52px"
                    letterSpacing="-0.5px"
                    color="rgba(0, 0, 0, 0.5)"
                    mb="16px"
                >
                    Complete a autenticação de dois fatores para aumentar sua segurança.
                </Text>

                {step === 1 &&
                    <Flex justifyContent="center" alignContent="center" alignItems="center" gap="8px">
                        <Flex>
                            <FirstStepIcon size={29} />
                        </Flex>
                        <Text fontSize="14px" fontWeight="400" lineHeight="14.52px" color="black">
                            Caso ainda não possua, instale um aplicativo de autenticação no seu celular. Algumas opções são: Google Authenticator, Duo, Microsoft Authenticator.
                        </Text>
                    </Flex>
                }

                {step === 2 &&
                    <>
                        <Flex justifyContent="center" alignContent="center" alignItems="center" gap="8px">
                            <Flex>
                                <SecondStepIcon size={29} />
                            </Flex>
                            <Text fontSize="14px" fontWeight="400" lineHeight="14.52px" color="black">
                                Abra o aplicativo de autenticação e utilize a câmera para ler o QR code abaixo ou insira o código manualmente
                            </Text>
                        </Flex>
                        <Flex justifyContent="center" alignItems="center" mt="32px" gap="20px" flexDirection="column">
                            <QRCodeSVG value={urlQrCode} />
                        </Flex>
                    </>
                }

                {step === 3 &&
                    <>
                        <Flex justifyContent="center" alignContent="center" alignItems="center" gap="8px">
                            <Flex justifyContent="center" alignContent="center" alignItems="center" h="100%">
                                <ThirdStep size={29} />
                            </Flex>
                            <Text fontSize="14px" fontWeight="400" lineHeight="14.52px" color="black">
                                Digite o código de 6 dígitos gerados pelo aplicativo de autenticação
                            </Text>
                        </Flex>
                        <Flex justifyContent="center" alignItems="center" mt="32px" flexDirection="column">
                            <HStack spacing="8px" justifyContent="center">
                                <PinInput
                                    type="number"
                                    value={pin}
                                    onChange={(value) => { setPin(value); setError(false); }}
                                    placeholder=""
                                    isInvalid={error}
                                    errorBorderColor="red.500"
                                >
                                    <PinInputField />
                                    <PinInputField />
                                    <PinInputField />
                                    <PinInputField sx={{ "&:nth-of-type(4)": { marginLeft: "24px" } }} />
                                    <PinInputField />
                                    <PinInputField />
                                </PinInput>
                            </HStack>
                            {error && <Text mb="-25px" fontSize="12px" color="red.500" mt={2}>{errorMessage}</Text>}
                        </Flex>
                    </>
                }
            </Modal>

            <Modal
                isOpen={isOpen && step === 4}
                title="Desativar Autenticação de dois fatores?"
                onClose={onClose}
                footer={{
                    primaryButton: {
                        children: "Desativar",
                        onClick: desative2FA,
                        loading,
                    },
                    secondaryButton: {
                        children: "Cancelar",
                        onClick: onClose,
                        variant: "outline",
                        loading,
                    },
                }}
            >
                <div style={{ display: "flex", alignItems: "flex-start", gap: "16px" }}>
                    <InfoIconOutlineYellow size={24} />
                    <div>
                        <Text fontSize="14px" color="rgba(0, 0, 0, 0.85)">
                            Tem certeza que deseja desativar a autenticação de dois fatores?
                        </Text>
                        <Text fontSize="14px" color="rgba(0, 0, 0, 0.85)">
                            Você irá perder uma camada de proteção da sua conta contra acessos não autorizados.
                        </Text>
                    </div>
                </div>
            </Modal>
        </>
    );
}
